"use strict";

var _httpCore = _interopRequireDefault(require("../httpCore"));

var _util = require("../util");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * 移除记录（需要有 REC_ID 字段）
 */

/**
 * 处理请求体
 * @param {object} reqBody 删除记录时发送给后端的请求体（未处理）
 *
 * @param {number} reqBody.resid 表资源 id
 * @param {array} reqBody.data 要删除的记录
 * @param {boolean} reqBody.isEditOrAdd 是否使用 'editoradd' 状态
 *
 */


var dealRequestBody = function dealRequestBody(reqBody) {
  var newReqBody = (0, _util.clone)(reqBody); // 防止改变传进来的 records ，从而影响外面

  var state = newReqBody.isEditOrAdd ? 'editoradd' : 'removed';
  newReqBody.data.forEach(function (record, index) {
    record._id = index + 1;
    record._state = state;
  });
  newReqBody.data = JSON.stringify(newReqBody.data);
  return newReqBody;
};

_httpCore.default.createApi('removeRecords', {
  method: 'post',
  url: '/api/100/table/Save'
}, dealRequestBody);